import React from 'react';
import styled from 'styled-components';
import { useTranslation } from '~/Locale';
import { COLORS } from '../constants';

const Container = styled.div`
  display: none;
  gap: 40px;
  padding: 10px 0 6px;
  width: 100%;
  justify-content: center;
  background: ${COLORS.black};

  /* Show only on touch devices without hover. */
  @media (hover: none) and (pointer: coarse) {
    display: flex;
  }
`;

const ArrowButton = styled.button`
  width: 72px;
  height: 52px;
  background: rgba(245, 180, 0, 0.12);
  border: 2px solid ${COLORS.yellow};
  border-radius: 12px;
  color: ${COLORS.yellow};
  font-size: 26px;
  cursor: pointer;
  -webkit-tap-highlight-color: transparent;
  transition: background 0.1s;
  display: flex;
  align-items: center;
  justify-content: center;

  &:active {
    background: rgba(245, 180, 0, 0.35);
  }
`;

export interface MobileControlsProps {
  onLeft: () => void;
  onRight: () => void;
}

const MobileControls = ({ onLeft, onRight }: MobileControlsProps) => {
  const { t } = useTranslation();

  return (
    <Container>
      <ArrowButton
        type="button"
        aria-label={t('Move left')}
        onPointerDown={onLeft}
      >
        ←
      </ArrowButton>
      <ArrowButton
        type="button"
        aria-label={t('Move right')}
        onPointerDown={onRight}
      >
        →
      </ArrowButton>
    </Container>
  );
};

export default MobileControls;
